import { Box, Flex, Text } from '@chakra-ui/react';
import { FC } from 'react';
import { Icon, IconButton } from '@lon/shared/components';

const ErrorToast: FC<{ message: string; onClose: () => void }> = ({
  onClose,
  message,
}) => {
  return (
    <Flex
      maxW="450px"
      backgroundColor="#A80000"
      color="white"
      gap={4}
      py={4}
      px={6}
      borderRadius="md"
      alignItems="start"
    >
      <Icon name="close-circle-outlined" />
      <Box>
        <Text
          fontSize="0.875rem"
          fontWeight="700"
          lineHeight="1.375rem"
          fontFamily="Verdana"
        >
          {message}
        </Text>
        <Text fontSize="0.875rem" lineHeight="1.375rem" fontFamily="Verdana">
          Check the entered values and try again or contact your Administrator.
        </Text>
      </Box>
      <IconButton
        icon={<Icon name="close-outlined" width="12px" height="12px" />}
        aria-label="Close toast"
        variant="ghost"
        color="white"
        onClick={onClose}
        size="xs"
        _hover={{
          color: 'white',
          background: 'blackAlpha.100',
        }}
      />
    </Flex>
  );
};

export default ErrorToast;
